import React from 'react'

import './_authLayout.scss'
import { useTranslation } from 'react-i18next'
import { useLocation } from 'react-router-dom'

import ImgInCircle from 'components/UI/ImgInCircle/ImgInCircle'

interface AuthLayoutProps {
    bgImg: string
    logo?: string
    children: React.ReactNode
}

const AuthLayout = ({ children, bgImg, logo = '/logo.png' }: AuthLayoutProps) => {
    const location = useLocation()
    const { t } = useTranslation()

    const isForm = (): boolean =>
        location.pathname === '/auth/signup/fan' ||
        location.pathname === '/auth/signup/model' ||
        location.pathname === '/auth/login/fan' ||
        location.pathname === '/auth/login/model' ||
        location.pathname === '/auth/recover/model'

    return (
        <div className='ll'>
            <div
                className='ll__cover'
                style={{ backgroundImage: `url(${bgImg})` }}
            />

            <div className={`ll__body ${isForm() ? 'll__body--form' : ''}`}>
                <ImgInCircle
                    type='login'
                    customClass={`ll__logos__circle ${
                        isForm() ? 'll__logos__circle--form' : ''
                    }`}
                >
                    <img
    src='/logo.png'
    alt={t('logo')}
    style={{ width: '60px', height: '60px' }}
/>
                </ImgInCircle>

                <div className='ll__body__children'>{children}</div>
            </div>
        </div>
    )
}

export default AuthLayout